import React, { useEffect, useState } from "react";
import {
    Card,
    Collapse,
    Typography,
    Input,
    Row,
    Col,
    Button,
    Space,
    message,
    Spin,
    Form,
} from "antd";
import {
    SendOutlined,
    CommentOutlined,
    DownOutlined,
    RightOutlined,
} from "@ant-design/icons";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import _commonService from "../../modules/commonService";
import { LoanOfficerReviewStatusId, UnderReviewStatusId } from "../../constants/DataConstants";
import _NewapplicationService from "../../modules/NewapplicationService";
import FormItemTextArea from "../../components/FormItems/FormItemTextArea";
import ButtonComponent from "../../components/Button/Button";

const { Panel } = Collapse;
const { Text } = Typography;

const ReviewCommentByApplicationIdAndSection = ({ CommentSectionName }) => {
    const [allComments, setAllComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const ApplicationObjId = parseInt(localStorage.getItem("ApplicationObjId"));
    const ApplicationStatusId = JSON.parse(localStorage.getItem("ApplicationStatusId"));
    const ApplicantName = localStorage.getItem("ApplicantName");
    const RoleId = Number(localStorage.getItem("RoleId") ?? 0);
    const [form] = Form.useForm();
    useEffect(() => {
        getApplicationReviewComment();
    }, []);

    const getApplicationReviewComment = async () => {
        try {
            setLoading(true);
            const res = await _NewapplicationService.getApplicationReviewCommentByApplicationIdAndSection(ApplicationObjId, CommentSectionName);

            if (res.data.IsSuccess) {
                const filteredRemarks = res.data.Obj?.filter((item) =>
                    (item.ReviewCommentsBy_BankerId && item.ReviewCommentsBy_BankerId > 0) ||
                    (item.IsCommentByApplicant === true)
                );
                setAllComments(filteredRemarks || []);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const handleAddComment = async (values) => {
        const { comment } = values;

        const reqObj = {
            Section: CommentSectionName,
            ApplicationId: ApplicationObjId,
            // Remarks: remarks.trim(),
            Comments: comment.trim(),
            ReviewCommentsBy_BankerId: null,
            ReviewCommentsBy_LoanOfficerId: null,
            ApplicationStatusId: ApplicationStatusId,
            RoleId: RoleId || null,
        };

        try {
            setLoading(true);
            const res = await _BankerService.addApplicationReviewComment(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                getApplicationReviewComment();
                form.resetFields();
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.error(err);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Spin spinning={loading}>
            {/* {comments.length > 0 && ( */}
            <Card
                className="card-section custom-section mt20"
                title={
                    <Space className="comments-title">
                        <CommentOutlined />
                        <Text >Comments</Text>
                    </Space>
                }
                style={{ borderRadius: 12 }}
            >
                {allComments
                    ?.filter(
                        (comment) =>
                            comment.Section === CommentSectionName &&
                            (comment.ReviewCommentsBy_BankerId > 0 || comment.IsCommentByApplicant)
                    ).length > 0 && (
                        <Collapse
                            accordion
                            collapsible="icon"
                            expandIcon={({ isActive }) =>
                                isActive ? <DownOutlined /> : <RightOutlined />
                            }
                            bordered={false}
                            className="card-section"
                        >
                            {allComments
                                ?.filter(
                                    (comment) =>
                                        comment.Section === CommentSectionName &&
                                        (comment.ReviewCommentsBy_BankerId > 0 || comment.IsCommentByApplicant)
                                )
                                .map((comment) => (
                                    <Panel
                                        key={comment.Id}
                                        header={
                                            <Row justify="space-between" style={{ width: "100%" }}>
                                                <Col>
                                                    <Text strong>
                                                        {comment.IsCommentByApplicant
                                                            ? "App"
                                                            : comment.ReviewCommentsBy_BankerId > 0
                                                                ? "B.O"
                                                                : "L.O"}{" "}
                                                        |

                                                        {" "}
                                                        {comment.IsCommentByApplicant
                                                            ? ApplicantName
                                                            : comment.ReviewCommentsBy_BankerId > 0
                                                                ? comment.ReviewCommentsBankerName
                                                                : comment.ReviewCommentsLoanOfficerName}
                                                    </Text>
                                                </Col>
                                                <Col>
                                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                                        {comment.CreatedDate
                                                            ? _commonService.formatDateTimeAMPM(comment.CreatedDate)
                                                            : "N/A"}
                                                    </Text>
                                                </Col>
                                            </Row>
                                        }
                                    >
                                        {/* <div>
                                    <Text><b>Remarks:</b> {comment.Remarks}</Text>
                                </div> */}
                                        <div>
                                            <Text><b>Comment:</b> {comment.Comments}</Text>
                                        </div>
                                    </Panel>
                                ))}
                        </Collapse>
                    )}

                {/* Comment Input Form */}
                {(ApplicationStatusId === 9) && (
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleAddComment}
                        initialValues={{ comment: "", remarks: "" }}
                    >
                        <Row gutter={16} style={{ marginTop: 16, borderTop: "2px solid rgba(244, 244, 245, 0.10)", paddingTop: 12 }}>

                            <Col span={22}>
                                {/* <Form.Item
                                name="comment"
                                rules={[{ required: true, message: "Comment is required" }]}
                            >
                                <Input.TextArea
                                    placeholder="comments *"
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                />
                            </Form.Item> */}
                                <FormItemTextArea
                                    name="comment"
                                    placeholder="comments *"
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                    rules={[{ required: true, message: "Comment is required" }]}
                                />
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "end" }}>
                                <Form.Item>
                                    {/* <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    <SendOutlined />
                                </Button> */}


                                    <ButtonComponent
                                        className="send-btn"
                                        type="primary"
                                        htmlType="submit"
                                        style={{ padding: "18px 17px" }}
                                        icon={<SendOutlined />}
                                        iconPosition="left"
                                        text=""
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                )}

            </Card>
            {/* )} */}
        </Spin>
    );
};

export default ReviewCommentByApplicationIdAndSection;
